import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import { Sidebar2023 } from 'views/SchoolProgram2023/components';
import Sidebar2024 from '../SchoolProgram2023/components/Sidebar2024';
import Archive2022 from '../SchoolProgram2023/components/Archive2022';


const Dasara2024 = () => {
    const theme = useTheme();
    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = (index) => {
        setCurrentImage(index);
        setViewerIsOpen(true);
    };

    const closeLightbox = () => {
        setCurrentImage(0);
        setViewerIsOpen(false);
    };

    const isMd = useMediaQuery(theme.breakpoints.up('md'), {
        defaultMatches: true,
    });


    const [config, setConfig] = useState({ base_image_url: '' });
    useEffect(() => {
        fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
            .then(response => response.json())
            .then(data => setConfig(data))
            .catch(error => console.error('Error fetching config:', error));
    }, []);

    const p1 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/1.webp`;
    const p2 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/2.webp`;
    const p3 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/3.webp`;
    const p4 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/4.webp`;
    const p5 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/5.webp`;
    const p6 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/6.webp`;
    const p7 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/7.webp`;
    const p8 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/8.webp`;
    const p9 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/9.webp`;
    const p10 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/10.webp`;
    const p11 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/11.webp`;
    const p12 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/12.webp`;
    const p13 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/13.webp`;
    const p14 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/14.webp`;
    const p15 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/15.webp`;
    const p16 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/16.webp`;
    const p17 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/17.webp`;
    const p18 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/18.webp`;
    const p19 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/19.webp`;
    const p20 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/20.webp`;
    const p21 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/21.webp`;
    const p22 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/22.webp`;
    const p23 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/23.webp`;
    const p24 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/24.webp`;
    const p25 = `${config.base_image_url}/home/events-activities/school-programs/Dasara/25.webp`;
   

    const photos = [
        {
            src: p1,
            source: p1,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p2,
            source: p2,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p3,
            source: p3,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p4,
            source: p4,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p5,
            source: p5,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p6,
            source: p6,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p7,
            source: p7,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p8,
            source: p8,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p9,
            source: p9,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p10,
            source: p10,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p11,
            source: p11,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p12,
            source: p12,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p13,
            source: p13,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p14,
            source: p14,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p15,
            source: p15,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p16,
            source: p16,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p17,
            source: p17,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p18,
            source: p18,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p19,
            source: p19,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p20,
            source: p20,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p21,
            source: p21,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p22,
            source: p22,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p23,
            source: p23,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p24,
            source: p24,
            rows: 1.5,
            cols: 1,
        },
        {
            src: p25,
            source: p25,
            rows: 1.5,
            cols: 1,
        },

    ];

    return (
        <Main>
            <Container>
                <Grid container spacing={4}>
                    <Grid item xs={12} md={8}>
                        <Box>

                            <Box >
                                <Typography variant='h4' align='center'>
                                    Dasara Celebrations
                                </Typography>
                                <Typography
                                    fontSize="x-small"
                                ><br /><br />
                                    Class: PRE-PRIMARY     Date: : 4th October 2024
                                </Typography>
                                

                                <br />
                                <Typography variant={'subtitle1'} align={'justify'}>
                                    With festive spirits soaring high, our little ones at National Public School, Yeshwanthpur, embraced the vibrant
                                    festival of Dasara with joy and enthusiasm, weaving together tradition and unity in a splendid celebration.
                                    <br></br>
                                    Adorned in colourful ethnic attire, our Pre-Primary students eagerly participated in various traditional activities
                                    centered around this auspicious festival. The day began with the serene recitation of melodious shlokas, filling the
                                    atmosphere with devotion and grace. A highlight of the celebration was the enchanting doll display, where the
                                    children explored the significance of each idol, symbolising the eternal triumph of good over evil. The festivities
                                    continued with a lively Dandiya dance, as our little ones twirled and swayed to the rhythmic beats, their smiles
                                    lighting up the room. Snack time was a delightful affair featuring homemade festive treats that added an extra
                                    touch of sweetness to the day. As the celebrations drew to a close, our young learners departed for their holidays,
                                    carrying with them the warmth, joy and timeless lessons of Dasara.
                                    <br></br>
                                    Wishing all our families a joyful and blessed Dasara, filled with love, light, and the enduring victory of goodness.
                                    <br></br>

                                </Typography>
                                <Typography variant='h4' align='center'>
                                HAPPY DASARA!
                                </Typography>
                            </Box>
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Honouring our traditions and celebrating the victory of good this Dasara!"
                                <br />

                            </Typography>

                            <Box>
                                <ImageList
                                    variant="quilted"
                                    cols={2}
                                    rowHeight={isMd ? 200 : 100}
                                    gap={isMd ? 16 : 4}
                                >
                                    {photos.map((item, i) => (
                                        <ImageListItem key={i} cols={item.cols} rows={item.rows}>
                                            <LazyLoadImage
                                                height={'100%'}
                                                width={'100%'}
                                                src={item.src}
                                                alt="..."
                                                effect="blur"
                                                onClick={() => openLightbox(i)}
                                                style={{
                                                    objectFit: 'cover',
                                                    filter:
                                                        theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                                                    cursor: 'poiner',
                                                    borderRadius: 8,
                                                }}
                                            />
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </Box>
                            <Box >
                            <Typography
                                variant={'h6'}
                                color={'primary'}
                                align={'center'}
                                fontWeight={'normal'}
                            ><br />
                                “Where festivities and memories entwine—Dasara blossoms in vibrant hues!"
                                <br />

                            </Typography>
                            </Box>
                            {viewerIsOpen && (
                                <Lightbox
                                    mainSrc={photos[currentImage].src}
                                    nextSrc={photos[(currentImage + 1) % photos.length].src}
                                    prevSrc={
                                        photos[(currentImage + photos.length - 1) % photos.length].src
                                    }
                                    onCloseRequest={() => closeLightbox()}
                                    onMovePrevRequest={() =>
                                        setCurrentImage((currentImage + photos.length - 1) % photos.length)
                                    }
                                    onMoveNextRequest={() =>
                                        setCurrentImage((currentImage + 1) % photos.length)
                                    }
                                    reactModalStyle={{ overlay: { zIndex: 1500 } }}
                                />
                            )}
                        </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <Box marginBottom={4}>
                            <Sidebar2024 />
                        </Box>
                        <Box marginBottom={4}>
                            <Archive2022 />
                        </Box>

                    </Grid>
                </Grid>
            </Container>
        </Main>

    );
};

export default Dasara2024;